import React from 'react';
import { Modal } from './ui';
export default function OldModal(props) {
  return <Modal {...props} />;
}
export { Modal };